import { render, staticRenderFns } from "./KinvaDocForm.vue?vue&type=template&id=0f10abe7&scoped=true"
import script from "./KinvaDocForm.vue?vue&type=script&lang=js"
export * from "./KinvaDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10abe7",
  null
  
)

export default component.exports